import { getParameterByName } from "../../utils";
import { matchesTCode } from "./utils";
const log = console;

export default {
  enable() {},
  init() {},
  enviar() {
    matchesTCode("afl--pml", function () {
      try {
        const clickID = getParameterByName("clickid");

        if (!clickID) {
          return;
        }

        // PML postback
        const url = `https://www.w4gb0ubgf.com/?nid=3280&transaction_id=${clickID}`;
        fetch(url, {
          method: "GET"
        })
          .then(r => log.log("PML | Success:", r))
          .catch(r => log.error("PML | Error:", r));
      } catch (error) {
        log.error("PML | Error:", error);
      }
    });
  }
};
